import { action, observable } from 'mobx';

import { LoadingStatusType } from './LoadingStatusType';

export class LoadingStatusState {
    @observable status: LoadingStatusType;

    constructor() {
        this.status = null;
    }

    @action load() {
        this.status = LoadingStatusType.isLoading;
    }

    @action loadSuccess() {
        this.status = LoadingStatusType.isLoaded;
    }

    @action loadError() {
        this.status = LoadingStatusType.isError;
    }
}
